import studentCabinetMetricEvents from 'modules/metrics/studentCabinet/studentCabinetMetricEvents'
import StudentCabinetMetrics from '@/models/metrics/StudentCabinetMetrics'

const clickToMetricsGoals = (data) => {
    const mainLink = document.getElementById('main-link')
    if (mainLink) {
        mainLink.onclick = function () {
            switch (data.page) {
                case "studentCabinet":
                    studentCabinetMetricEvents(StudentCabinetMetrics.BreadcrumbsToMainPage)
                    break;
            }
        }
    }
}

export default ((data) => { clickToMetricsGoals(data) })